import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import AirspaceResponsibleUnitiesAdd from './Elements/AirspaceResponsibleUnitiesAdd'
import AirspaceResponsibleUnityLocationsAdd from './Elements/AirspaceResponsibleUnityLocationsAdd'
import AirspaceResponsiblePanAdd from './Elements/AirspaceResponsiblePanAdd'
import AirspaceResponsibleAdrAdd from './Elements/AirspaceResponsibleAdrAdd'
import AirspaceResponsibleAppAdd from './Elements/AirspaceResponsibleAppAdd'

import Select from 'react-select';
import getLocale from '../../i18n/getLocale';

class AirspaceResponsiblesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: null,
      name: null,
      email: null,
      country_id: null,
      countries_select: [],
      locations_select: [],
      airspace_responsible_unities_select: [],
      airspace_responsible_unities: {},
      airspace_responsible_unity_locations: {},
      airspace_responsible_route_navigation_fees: {},
      airspace_responsible_airport_control_fees: {},
      airspace_responsible_approach_control_fees: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.refreshUpdated = this.refreshUpdated.bind(this);
    this.refreshSelect = this.refreshSelect.bind(this);
    this.refreshLocations = this.refreshLocations.bind(this);
    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/controlador/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/controladores');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            email: responseJson.data.main.email,
            country_id: responseJson.data.main.country_id,
            countries_select: responseJson.data.countries_select,
            locations_select: responseJson.data.locations_select,
            airspace_responsible_unities_select: responseJson.data.airspace_responsible_unities_select,
            airspace_responsible_unities: responseJson.data.airspace_responsible_unities,
            airspace_responsible_unity_locations: responseJson.data.airspace_responsible_unity_locations,
            airspace_responsible_route_navigation_fees: responseJson.data.airspace_responsible_route_navigation_fees,
            airspace_responsible_airport_control_fees: responseJson.data.airspace_responsible_airport_control_fees,
            airspace_responsible_approach_control_fees: responseJson.data.airspace_responsible_approach_control_fees,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      email: this.state.email,
      country_id: this.state.country_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/controlador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshUpdated() {
    this.setState({updated: 0});
  }
  refreshSelect(airspace_responsible_unities_select) {
    this.setState({airspace_responsible_unities_select: airspace_responsible_unities_select});
  }
  refreshLocations(airspace_responsible_unities_select, airspace_responsible_unity_locations) {
    this.setState({airspace_responsible_unities_select: airspace_responsible_unities_select, airspace_responsible_unity_locations: airspace_responsible_unity_locations, updated: 1});
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.titulo}</h3>
      <Link to="/controladores" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.formulario.Nome}:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.formulario.Email}:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.formulario.Pais}:</label>
              <Select
                className="form-field-name"
                name="country_id"
                value={this.state.country_id}
                searchable={true}
                placeholder={this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.formulario.placeHolder.SelecionarPais}
                onChange={this.handleSelectChange.bind(this, 'country_id')}
                options={this.state.countries_select}
              />    
            </div>
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ResponsaveisPeloEspacoAereo.EditarResponsaveisPeloEspacoAereo.formulario.botaoSalvarEdicao}</button>
      </form>
      {/* <hr />
      <AirspaceResponsibleUnitiesAdd RequestApi={self.refs.request_api} handleAlert={this.handleAlert} refreshSelect={this.refreshSelect} refreshLocations={this.refreshLocations} id={this.state.id} data={this.state.airspace_responsible_unities} />
      <hr />
      <AirspaceResponsibleUnityLocationsAdd RequestApi={self.refs.request_api} handleAlert={this.handleAlert} id={this.state.id} airspace_responsible_unities_select={this.state.airspace_responsible_unities_select} locations_select={this.state.locations_select} data={this.state.airspace_responsible_unity_locations} updated={this.state.updated} refreshUpdated={this.refreshUpdated}/> */}
      <hr />
      <AirspaceResponsiblePanAdd RequestApi={self.refs.request_api} handleAlert={this.handleAlert} id={this.state.id} data={this.state.airspace_responsible_route_navigation_fees}/>
      <hr />
      <AirspaceResponsibleAdrAdd RequestApi={self.refs.request_api} handleAlert={this.handleAlert} id={this.state.id} data={this.state.airspace_responsible_airport_control_fees}/>
      <hr />
      <AirspaceResponsibleAppAdd RequestApi={self.refs.request_api} handleAlert={this.handleAlert} id={this.state.id} data={this.state.airspace_responsible_approach_control_fees}/>
      <hr />
    </div>
  </div>
</div>
    );
  }
}

export default AirspaceResponsiblesEdit;



// WEBPACK FOOTER //
// ./src/Components/AirspaceResponsibles/AirspaceResponsiblesEdit.js